import React from 'react'

// Components
import EmptyHeader from 'containers/EmptyHeader'
import { Link } from '@sketch/components'

// Styles
import {
  Container,
  ErrorContainer,
  StyledErrorMessage,
} from './PartnerExpiredWorkspaceError.styles'

// Icons
import { ReactComponent as ExclamationMarkIcon } from '@sketch/icons/exclamation-mark-triangle-64-svg'

const PartnerExpiredWorkspaceError: React.FC = () => (
  <Container>
    <EmptyHeader />
    <ErrorContainer>
      <StyledErrorMessage
        title="The Workspace you’re trying to join has expired"
        icon={<ExclamationMarkIcon />}
      >
        To join this Workspace, please email{' '}
        <Link external href="mailto:partners@sketch.com" isUnderlined>
          partners@sketch.com
        </Link>
      </StyledErrorMessage>
    </ErrorContainer>
  </Container>
)

export default PartnerExpiredWorkspaceError
